module.exports = __webpack_public_path__ + "static/media/Internationalpic2@2x.77c3cfbd.png";